<template>
  <div>
    <div class="border-b-2 border-grey-200 py-6">
      <Container use-full-width>
        <div class="flex items-start justify-between gap-10">
          <!-- FILTER CATEGORY DESKTOP -->
          <AnimatedContainer :stagger="0.05">
            <ul class="flex flex-wrap gap-x-12 gap-y-3 self-stretch pt-2 max-lg:hidden">
              <li v-for="category in categories" :key="category?.id" class="slide-left">
                <button
                  :class="{ 'text-primary-900': filter?.category === category?.slug }"
                  class="font-semibold transition-colors typo-subtitle"
                  type="button"
                  @click="onFilterCategory(category?.slug || '')"
                >
                  {{ category?.title }}
                </button>
              </li>
            </ul>
          </AnimatedContainer>

          <!-- FILTER CATEGORY MOBILE -->
          <SingleSelect
            title="download-filter-category"
            :model-value="categories.find((category) => category?.slug === filter?.category) || undefined"
            placeholder="auswählen"
            class="mt-0.5 pt-2 lg:hidden"
            :options="categories || []"
            @update:model-value=" filter ? filter.category = $event.slug : null"
          />

          <!-- OPEN CLOSE SEARCH-COLLAPSE -->
          <AppButton class="shrink-0" @click="isSearchCollapseOpen = !isSearchCollapseOpen">
            <template #icon>
              <Transition tag="div" name="fade" mode="out-in">
                <IconClose v-if="isSearchCollapseOpen" class="size-7" />
                <IconFilter v-else class="size-7" />
              </Transition>
            </template>
          </AppButton>
        </div>
      </Container>
    </div>
    <div ref="searchCollapse" class="shadow-md" :class="{ 'h-0 overflow-hidden': !isMounted }">
      <Container use-full-width class="flex gap-y-8 py-14 gap-x-default max-lg:flex-col">
        <div class="flex-1 lg:max-w-144">
          <label class="mb-1.5 block text-grey-300 typo-subtitle" for="download-search">{{ $t('search_dl_center') }}</label>
          <SearchInput
            id="download-search"
            :value="filter ? filter.searchTerm : ''"

            @input="filter ? filter.searchTerm = $event : ''"
          />
        </div>
        <div class="flex-1 lg:max-w-144">
          <label class="mb-1.5 block text-grey-300 typo-subtitle" for="headlessui-listbox-button-download-filter-language">{{ $t('language') }}</label>
          <SingleSelect
            title="download-filter-language"
            :model-value="languages.find((language) => language?.slug === filter?.language) || undefined"
            placeholder="auswählen"
            :options="languages || []"
            variant="gray"
            size="lg"
            @update:model-value="filter ? filter.language = $event.slug : null"
          />
        </div>
      </Container>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DownloadFilterType } from '~/components/main-components/Downloadcenter.vue'

withDefaults(
  defineProps<{
    categories: Array<{
      id: string
      slug: string
      title: string
    }>
    languages: Array<{
      id: string
      slug: string
      title: string
    }>
  }>(),
  {
    categories: () => [],
    languages: () => [],
  },
)
const filter = defineModel<DownloadFilterType>()

// Collapse Search
const searchCollapse = ref<HTMLElement | undefined>(undefined)
const isSearchCollapseOpen = useCollapse(searchCollapse, {
  duration: 300,
  initiallyClosed: false,
})

function onFilterCategory(slug: string) {
  if (!filter.value) {
    return
  }
  if (filter.value.category === slug) {
    filter.value.category = 'all'

    return
  }
  filter.value.category = slug
}

const isMounted = ref<boolean>(false)
onMounted(() => {
  // To hide the collapse before it is mounted (workaround) when it should be collapsed initially
  isMounted.value = true
})
</script>
